export const CREATE_SUB_ACCOUNT_PENDING = "CREATE_SUB_ACCOUNT_PENDING";
export const CREATE_SUB_ACCOUNT_SUCCESS = "CREATE_SUB_ACCOUNT_SUCCESS";
export const CREATE_SUB_ACCOUNT_FAIL = "CREATE_SUB_ACCOUNT_FAIL";

export const DELETE_SUB_ACCOUNT_PENDING = "DELETE_SUB_ACCOUNT_PENDING";
export const DELETE_SUB_ACCOUNT_SUCCESS = "DELETE_SUB_ACCOUNT_SUCCESS";
export const DELETE_SUB_ACCOUNT_FAIL = "DELETE_SUB_ACCOUNT_FAIL";

export const RESET_PASSWORD_SUB_ACCOUNT_PENDING =
  "RESET_PASSWORD_SUB_ACCOUNT_PENDING";
export const RESET_PASSWORD_SUB_ACCOUNT_SUCCESS =
  "RESET_PASSWORD_SUB_ACCOUNT_SUCCESS";
export const RESET_PASSWORD_SUB_ACCOUNT_FAIL =
  "RESET_PASSWORD_SUB_ACCOUNT_FAIL";

export const CHANGE_PASSWORD_SUB_ACCOUNT_PENDING =
  "CHANGE_PASSWORD_SUB_ACCOUNT_PENDING";
export const CHANGE_PASSWORD_SUB_ACCOUNT_SUCCESS =
  "CHANGE_PASSWORD_SUB_ACCOUNT_SUCCESS";
export const CHANGE_PASSWORD_SUB_ACCOUNT_FAIL =
  "CHANGE_PASSWORD_SUB_ACCOUNT_FAIL";

export const SET_SUB_ACCOUNT_LIMIT = "SET_SUB_ACCOUNT_LIMIT";
export const SET_SUB_ACCOUNTS = "SET_SUB_ACCOUNTS";
